import { render, staticRenderFns } from "./OldJobs.vue?vue&type=template&id=d0d71bc2&scoped=true"
import script from "./OldJobs.vue?vue&type=script&lang=js"
export * from "./OldJobs.vue?vue&type=script&lang=js"
import style0 from "./OldJobs.vue?vue&type=style&index=0&id=d0d71bc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0d71bc2",
  null
  
)

export default component.exports